import React from 'react';
import { motion } from 'framer-motion';

// Scroll-driven 3D depth entrance — tilts/floats elements into place as they enter the viewport
export const ScrollDepthReveal = ({ children, className = '', delay = 0, direction = 'up' }) => {
  const initial =
    direction === 'up'
      ? { opacity: 0, y: 90, rotateX: -22, scale: 0.9 }
      : direction === 'down'
      ? { opacity: 0, y: -90, rotateX: 22, scale: 0.9 }
      : direction === 'left'
      ? { opacity: 0, x: -90, rotateY: 22, scale: 0.9 }
      : { opacity: 0, x: 90, rotateY: -22, scale: 0.9 };

  return (
    <motion.div
      className={className}
      initial={initial}
      whileInView={{ opacity: 1, x: 0, y: 0, rotateX: 0, rotateY: 0, scale: 1 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      style={{ transformPerspective: 1200 }}
    >
      {children}
    </motion.div>
  );
};

export default ScrollDepthReveal;
